import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { message } from 'antd'
import requests from '../../../axios/requests'
import { setUserTrajectory } from '../../../redux/actions/userActions'
import { sameName } from './genUtils'

// Учебный план (корзина навыков): добавить/убрать навык и перечитать список с сервера,
// чтобы счётчики планов и курсов у навыков всегда были актуальными.
export default function useTrajectory() {
  const dispatch = useDispatch()
  const { trajectorySkills } = useSelector((state) => state.Reducer)
  const list = trajectorySkills || []

  const refresh = useCallback(
    () =>
      requests.quests
        .get_trajectory_skill()
        .then(({ data }) => dispatch(setUserTrajectory(data || [])))
        .catch((err) => console.error(err)),
    [dispatch]
  )

  const has = useCallback((name) => list.some((s) => sameName(s.name, name)), [list])

  const add = useCallback(
    (skill) => {
      const name = typeof skill === 'string' ? skill : skill?.name
      if (!name || list.some((s) => sameName(s.name, name))) return Promise.resolve()
      dispatch(setUserTrajectory([...list, { id: `tmp-${name}`, name }]))
      return requests.quests
        .add_trajectory_skill({ name, index: list.length + 1 })
        .then(refresh)
        .catch((err) => {
          console.error(err)
          message.error('Не удалось добавить навык')
          refresh()
        })
    },
    [dispatch, list, refresh]
  )

  const addMany = useCallback(
    async (skills) => {
      const names = []
      skills.forEach((sk) => {
        const name = typeof sk === 'string' ? sk : sk?.name
        if (name && !list.some((s) => sameName(s.name, name)) && !names.some((n) => sameName(n, name)))
          names.push(name)
      })
      if (!names.length) return
      dispatch(setUserTrajectory([...list, ...names.map((name) => ({ id: `tmp-${name}`, name }))]))
      for (let i = 0; i < names.length; i++) {
        try {
          await requests.quests.add_trajectory_skill({ name: names[i], index: list.length + i + 1 })
        } catch (err) {
          console.error(err)
        }
      }
      refresh()
    },
    [dispatch, list, refresh]
  )

  const remove = useCallback(
    (skill) => {
      const name = typeof skill === 'string' ? skill : skill?.name
      if (!name) return Promise.resolve()
      dispatch(setUserTrajectory(list.filter((s) => !sameName(s.name, name))))
      return requests.quests
        .remove_trajectory_skill(name)
        .catch((err) => {
          console.error(err)
          refresh()
        })
    },
    [dispatch, list, refresh]
  )

  const toggle = useCallback((skill) => (has(skill?.name || skill) ? remove(skill) : add(skill)), [
    has,
    add,
    remove,
  ])

  return { list, has, add, addMany, remove, toggle, refresh }
}
